import React from 'react';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import { Link } from 'react-router-dom';

const SortableItem = SortableElement(({seriesElement, workoutId}) => {
  return(
    <div key={seriesElement.id}>

      <div className="workout-item">
        <i className="fas fa-dumbbell"></i>
        <div className="workout-info">
          <Link to={`/workouts/${workoutId}/series/${seriesElement.id}`} >
            <h4>{seriesElement.name}</h4>
          </Link>
          <p>
            {`${
              seriesElement.is_custom_reps
                ? `${seriesElement.reps} reps`
                : seriesElement.method
            }
            , ${seriesElement.sets} Sets`}
          </p>
          <ul>
            {seriesElement.exercises &&
              seriesElement.exercises.map((exercise, index) => {
                return <li key={index}>{exercise}</li>;
              })}
          </ul>
        </div>
      </div>
    </div>
  );
});

const WorkoutSeries = SortableContainer(({series, workoutId}) => {
  return (
    <div className="workout-series-list">
      {series &&
        series.map((seriesElement, index) => {
          return (
            <SortableItem
              key={'item-'+seriesElement.id}
              seriesElement={seriesElement}
              workoutId={workoutId}
              index={index}
            />
          );
        })
      }
    </div>
  );
});

export default WorkoutSeries;
